import { NgModule, Injectable } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { UpgradeModule } from '@angular/upgrade/static'
import { AppComponent } from './app.component'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { Observable } from 'rxjs';

function unescapeHtmlNumericCodes(str) {
	return str.replace(/&#(\d+);/g, function (m, n) {
		return String.fromCharCode(n)
	})
}

function normalizeDomain(url) {
	if (!url) return "";
	return url.replace(/^http(s)?:\/\//, '').replace(/\/.*$/, '');
}

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
		let config: any = {}
		if((window as any).tagmeConfig)
			config = JSON.parse(unescapeHtmlNumericCodes((window as any).tagmeConfig))

		const rootUrl = normalizeDomain(config?.rootUrl);
		const backendUrl = normalizeDomain(config?.backendUrl);

		if (
			req.url.includes(rootUrl) ||
			req.url.includes(backendUrl)
		) {
			req = req.clone({
				withCredentials: true
			});
		} 
		
      	return next.handle(req);
  }
}

@NgModule({
	imports: [BrowserModule, UpgradeModule],
	declarations: [AppComponent],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true }
	],
	bootstrap: [AppComponent],
	entryComponents: [],
})
export class AppModule {}
